<template>
<div class="conteudo-aula row">
  <div class="video" :class="{ 'col-md-8 pl-0 pr-0 mb-2' : cadernoLateral.status }">
    <!-- thumb topico -->
    <div class="thumb-sala" :class="{ 'd-none': videoIniciado }" :style="{ background: 'url(' + background + '), url(' + backgroundPadrao + ') no-repeat center center' + corOpacidade }">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-12 thumb-topico text-center mb-2 mb-md-3 mb-lg-4 mb-xl-5">
            <p>Tópico</p>
            <p>{{ titulo }}</p>
          </div>
          <div class="col-4 text-right">
            <img :src="thumbLogo" @error="thumbLogo = thumbLogoPadrao" class="img-fluid thumb-jaleko" alt="Logo Jaleko">
          </div>
          <div class="col-4 text-center">
            <i class="far fa-play-circle" @click="iniciarVideo"></i>
          </div>
          <div class="col-4 text-left">
            <img :src="imagem" class="img-fluid thumb-curso" :alt="`Capa do curso de ${nomeCurso}`">
          </div>
          <div class="col-12 thumb-prof text-center mt-2 mt-md-3 mt-xl-5" v-if="professor">
            <p>Professor</p>
            <p>{{ professor }}</p>
          </div>
        </div>
      </div>
    </div>
    <input type="hidden" id="video_id" value="632">
    <input type="hidden" id="parei-aqui" value="33.333">
    <video ref="videoS3" id="clip" controls="true" preload="metadata" width=100%  data-setup="{}" controlsList="nofullscreen nodownload">
      <source :src="urlVideo" ref="videoS3src" type='video/mp4'/>
    </video>
  </div>
    <div class="col-md-4" v-if="cadernoLateral.status">
    <meu-caderno :ementa-id="ementaId" :licao="licao" :anotacoes="anotacoes" :isVideo="true" ref="meuCaderno" />
  </div>
</div>
</template>

<script>
import MeuCaderno from '../apoio-topico/MeuCaderno'
import ImageUtils from '@/core/utils/image-utils'
import Constants from '@/core/constants/constants'
import SalaAulaAPI from '@/api/sala-aula-api'
import VideosAPI from '@/api/videos-api'

export default {
  name: 'TopicoVideoS3',
  components: { MeuCaderno },
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      link: '',
      titulo: '',
      inicio: 0,
      professor: '',
      imagem: '',
      nomeCurso: '',
      videoIniciado: false,
      ementaId: null,
      licao: null,
      anotacoes: null,
      tipoOrigemId: null,
      vimeo_video: '',
      optionsVimeo: {
        responsive: true,
        height: '450'
      },
      thumbLogo: '',
      thumbLogoPadrao: '',
      background: '',
      backgroundPadrao: '',
      corOpacidade: '',
      intervalId: null,
      tempoAtualVideo: null,
      tempoTotalVideo: null

    }
  },
  created () {
    this.initializeThumbsAndColors()
  },
  computed: {
    cadernoLateral: function () {
      return this.$store.getters.caderno_lateral
    },
    urlVideo: function () {
      return process.env.VUE_APP_BUCKET_STREAM + this.vimeo_video + '.mp4'
    }
  },
  methods: {
    obterTopico: function () {
      this.videoIniciado = false
      this.vimeo_video = this.ementaCurso.topico_escolhido.vimeo_video
      this.link = this.ementaCurso.topico_escolhido.link
      this.professor = this.ementaCurso.topico_escolhido.professor ? this.ementaCurso.topico_escolhido.professor.nome : ''

      this.titulo = this.ementaCurso.topico_escolhido.titulo.length > Constants.TAMANHO_LIMITE_TITULO_TOPICO
        ? this.ementaCurso.topico_escolhido.titulo.substring(0, Constants.TAMANHO_LIMITE_TITULO_TOPICO) + '...' : this.ementaCurso.topico_escolhido.titulo

      this.ementaId = this.ementaCurso.topico_escolhido.ementa_id

      this.tipoOrigemId = this.ementaCurso.topico_escolhido.tipo_origem_id && this.ementaCurso.topico_escolhido.tipo_origem_id

      this.imagem = this.ementaCurso.curso_estrutura.foto ? ImageUtils.obterUrlCompletaImagem(`${this.ementaCurso.curso_estrutura.foto}`, 'cursos-plataforma/') : ''

      this.nomeCurso = this.ementaCurso.curso_estrutura.nome

      let topicoId
      if (this.ementaCurso.topico_escolhido.id) topicoId = this.ementaCurso.topico_escolhido.id
      else if (this.ementaCurso.topico_escolhido.topico_id) topicoId = this.ementaCurso.topico_escolhido.topico_id

      const estruturaCurso = this.ementaCurso.curso_estrutura
      const licoes = estruturaCurso.modulos.flatMap(modulo => modulo.licoes)
      const licaoTopico = licoes.find(licao => licao.topicos.find(topico => topico.id === topicoId))
      const nomeCategoria = this.ementaCurso.breadcrumb && this.ementaCurso.breadcrumb.nome_categoria ? this.ementaCurso.breadcrumb.nome_categoria : ''
      this.licao = { id: licaoTopico.id, nome: licaoTopico.titulo, nomeCategoria: nomeCategoria, curso: { id: this.ementaCurso.curso_estrutura.id, nome: this.ementaCurso.curso_estrutura.nome } }
      this.anotacoes = this.ementaCurso.anotacoes && this.ementaCurso.anotacoes.length ? this.ementaCurso.anotacoes[this.ementaCurso.anotacoes.length - 1].anotacao : ''

      SalaAulaAPI.obterTopicoUsuario(this.ementaId).then(data => {
        if (data.data && data.data.parei_aqui) {
          this.inicio = data.data.parei_aqui
        }
      })
    },

    iniciarVideo: function () {
      this.videoIniciado = true
      this.$refs.videoS3.load()
      this.$refs.videoS3.play()
    },

    initializeThumbsAndColors: function () {
      this.background = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/bgVideo.png`
      this.backgroundPadrao = require('@/assets/img/icons-thumb.png')
      this.thumbLogo = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/thumbLogo.png`
      this.thumbLogoPadrao = require('@/assets/img/thumb-jaleko.png')
      this.corOpacidade = process.env.VUE_APP_COR_PRIMARIA
    },

    loadedMetadata: function () {
      this.$refs.videoS3.currentTime = this.inicio
    },

    onPause: function () {
      VideosAPI.atualizarTempoVideo(this.ementaId, this.$refs.videoS3.currentTime)
    },

    onEnded: function () {
      this.concluiVideo()
    },

    concluiVideo () {
      this.tempoAtualVideo = this.$refs.videoS3 && this.$refs.videoS3.currentTime
      this.tempoTotalVideo = this.$refs.videoS3 && this.$refs.videoS3.duration
      this.$store.dispatch('concluiEmentaVideo', { ementaId: this.ementaId, tempoAtual: this.tempoAtualVideo, tempoTotal: this.tempoTotalVideo })
    }
  },
  mounted () {
    this.link = ''
    this.obterTopico()

    this.$refs.videoS3.addEventListener('loadedmetadata', this.loadedMetadata, false)
    this.$refs.videoS3.addEventListener('pause', this.onPause, false)
    this.$refs.videoS3.addEventListener('ended', this.onEnded, false)

    this.intervalId = setInterval(() => {
      this.concluiVideo()
    }, 3000)
  },

  watch: {
    ementaCurso: function () {
      this.link = ''
      this.initializeThumbsAndColors()
      this.obterTopico()
    },

    '$route.params': function () {
      clearInterval(this.intervalId)

      // Como a pagina inteira nao e carregada, resetamos o data deste componente quando os parametros da rota sao alterados
      Object.assign(this.$data, this.$options.data.apply(this))

      this.$refs.videoS3src.setAttribute('src', this.urlVideo)
      this.$refs.videoS3.load()

      this.intervalId = setInterval(() => {
        this.concluiVideo()
      }, 3000)
    }
  }
}
</script>

<style scoped>

</style>
